import { jsx as a, Fragment as $ } from "react/jsx-runtime";
import { u as d } from "./index-6a632112.mjs";
import { Q as u, s as h, b as l, d as x, e as b, B as w } from "./themes-5f0b3c3d.mjs";
import { t as g } from "./textStyles-42cab346.mjs";
import "react";
import { SingleSelectInput as k } from "./selectInput.js";
import { useWindowDimensions as v } from "./useWindowDimensions.js";
import "./lineHeights-72d3110c.mjs";
import "./fontWeights-a25f8f91.mjs";
import "./cancelCloseFilled-b2127cb6.mjs";
import "./types-b577bf77.mjs";
import "./caretDown-8ff83493.mjs";
import "./caretUp-e6db3a6f.mjs";
import "./label-3b996c7d.mjs";
import "./tooltip.js";
import "./zIndices-d07533f3.mjs";
import "./getElementPosition-5026bb28.mjs";
import "./popupTip.js";
import "./closeButton.js";
import "./cancelClose-87fdf326.mjs";
import "./iconButton.js";
import "./button.js";
import "./accessibility.js";
import "./checkmarkFilled-c2b01ef1.mjs";
import "./informationFilled-05d57719.mjs";
import "./uniqueId-321287e8.mjs";
import "./index-39f84169.mjs";
import "./radio.js";
import "./helperText-698f3ed9.mjs";
import "./warningFilled-691cfde1.mjs";
import "./checkbox.js";
import "./checkmark-84b5274e.mjs";
import "./subtract-848336fd.mjs";
import "./menu.js";
import "./moreVertical-dc2e97a2.mjs";
import "./textInput.js";
import "./tags.js";
import "./screenReaderOnly.js";
const S = d.div`
  display: flex;
  flex-direction: column;

  max-width: 100%;

  @media ${u.tabletAndUp} {
    max-width: 184px;
  }
`, y = d.span`
  display: inline-flex;
  width: 100%;
  box-sizing: border-box;
  align-items: center;
  flex-shrink: 0;
  padding: ${h["4x"]};
  border-left: ${l["1x"]} solid #d1d5d9;

  &:focus-visible {
    outline: ${({ theme: o }) => `${l["2x"]} solid ${o.components.tabs.tabFocusRing}`};
    border-radius: ${l["1x"]};
    outline-offset: ${l["2x"]};
    position: relative;
    z-index: 99;
  }
  border-left: ${({ $isActive: o, theme: r, $isDisabled: t }) => o && !t ? `${l["2x"]} solid ${r.components.tabs.tabActiveBottomBorder};` : `${l["2x"]} solid #d1d5d9;`};
  cursor: ${({ $isDisabled: o }) => o ? "not-allowed" : "pointer"};

  &:hover {
    ${({ $isActive: o, $isDisabled: r, theme: t }) => !r && `border-left: ${l["2x"]} solid ${o ? t.components.tabs.tabActiveBottomBorder : t.components.tabs.tabHoverBottomBorder};
      background-color: #fafafb;
      cursor: pointer;

    z-index: 99;
      

      
      `}
  }
`, B = d.span`
  text-align: left;
  font-family: ${x.body};
  font-style: normal;
  font-size: ${g.headline.xs.fontSize};
  font-weight: ${b.medium.S.fontWeight};
  color: ${({ $isActive: o, $isDisabled: r, theme: t }) => r ? t.components.tabs.textDisabledColor : o ? t.components.tabs.textActiveColor : t.components.tabs.textDefaultColor};

  cursor: ${({ $isDisabled: o }) => o ? "not-allowed" : "pointer"};

  display: flex;
  align-items: center;
  width: 100%;
  line-height: ${b.medium.S.lineHeight};
  overflow: hidden;
  text-overflow: ellipsis;

  display: -webkit-box;

  -webkit-line-clamp: 3; /* Limit to 3 lines */
  -webkit-box-orient: vertical;
`, bo = ({
  activeJumpLink: o = 0,
  setActiveJumpLink: r,
  jumplinks: t = []
}) => {
  const { width: c } = v(), p = (n, s) => {
    n || r(s);
  }, f = (n) => {
    let s = 0;
    t.forEach((i, e) => {
      if (i.label === n?.label) {
        s = e;
        return;
      }
    }), r(s);
  };
  return /* @__PURE__ */ a(S, { children: t && (() => {
    const n = /* @__PURE__ */ a(
      k,
      {
        placeholder: "Select...",
        options: t.map((i) => ({
          label: i?.label,
          value: i?.label,
          disabled: i?.disabled
        })),
        selected: `${t[o]?.label}`,
        onOptionSelect: f,
        size: "medium",
        maxItems: 6
      }
    ), s = t.map((i, e) => e >= 8 ? null : /* @__PURE__ */ a(
      y,
      {
        role: "tab",
        $isActive: o === e,
        "aria-selected": o === e,
        "data-focus": o === e,
        onClick: () => p(i.disabled, e),
        tabIndex: 0,
        $isDisabled: i?.disabled || !1,
        onKeyDown: (m) => {
          (m.code === "Enter" || m.code === "Space") && p(i.disabled, e);
        },
        "aria-disabled": i.disabled,
        "data-testid": "Jumplink-testid",
        ...i.accessibilityOptions,
        children: /* @__PURE__ */ a(
          B,
          {
            $isDisabled: i?.disabled || !1,
            $isActive: o === e,
            children: i.label
          }
        )
      },
      `${i.label.toLocaleLowerCase()}-${e}`
    ));
    return /* @__PURE__ */ a($, { children: c < w.tabletMin ? n : s });
  })() });
};
export {
  bo as JumpLink
};
